import { CHART_GRAPH, CHART_TYPE } from '@/entities/chart/model/constants';
import { useMultiSeriesExport } from '@/features/(charts)/chart-renderer/hooks/use-table-export/useMultiSeriesExport';
import { useSingleSeriesExport } from '@/features/(charts)/chart-renderer/hooks/use-table-export/useSingleSeriesExport';

export type ChartExportProps = {
  chartBase: ChartBase;
  tableData?: ChartTableRes;
  title?: string;
};

const useChartExport = (props: ChartExportProps) => {
  const { chartBase, tableData, title } = props;

  const isMultiSeries =
    chartBase.type === CHART_TYPE.CROSS_AXIS &&
    chartBase.graph === CHART_GRAPH.TABLE;

  const multiSeriesExport = useMultiSeriesExport({
    chartBase,
    tableData,
    title,
    enabled: isMultiSeries,
  });

  const singleSeriesExport = useSingleSeriesExport({
    chartBase,
    tableData,
    title,
    enabled: !isMultiSeries,
  });

  return () => {
    if (isMultiSeries) return multiSeriesExport();
    else return singleSeriesExport();
  };
};

export default useChartExport;
